import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { BsArrowLeftCircle } from "react-icons/bs";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import HamburgerButton from "./HamburgerMenuButton/HamburgerButton";
import { FaRegCalendarCheck } from "react-icons/fa";
import { FaHourglassEnd, FaUserTimes } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { RiLogoutCircleLine } from "react-icons/ri";
import { FaUserAstronaut } from "react-icons/fa";
import { HiTrendingUp } from "react-icons/hi";

const Sidebar = ({ open, setSidebarOpen }) => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();

  const Menus = [
    { title: "Daily Revenue", path: "/Dailylogs", src: <FaRegCalendarCheck size={20} /> },
    { title: "MIS", path: "/mis-data", src: <MdOutlineMiscellaneousServices size={22} /> },
    { title: "Hourly logs", path: "/one_hour", src: <FaHourglassEnd size={18} /> },
    { title: "User logs", path: "/userLogs", src: <FaUserAstronaut size={20} /> },
    { title: "BlackList User", path: "/black-list", src: <ImCross size={16} /> },
    { title: "Unsubscribe User", path: "/unsub", src: <FaUserTimes size={20} /> },
    { title: "Trend", path: "/hourly-trend", src: <HiTrendingUp size={22} /> },
     {title: "Traffic Data", path: "/traffic-data", src: <MdOutlineMiscellaneousServices size={22} />},
    { title: "Logout", path: "/logout", src: <RiLogoutCircleLine size={22} /> },
   
  ];

  // lock body scroll when mobile menu open
  useEffect(() => {
    if (mobileMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenu]);

  return (
    <>
      {/* Desktop Sidebar */}
      <div
        className={`${
          open ? "w-64" : "w-20"
        } fixed top-0 left-0 bottom-0 hidden lg:flex flex-col duration-300 bg-white border-r border-slate-200 shadow-[4px_0_24px_rgba(0,0,0,0.02)] z-40 transition-all ease-in-out`}
      >
        <BsArrowLeftCircle
          className={`${
            !open && "rotate-180"
          } absolute text-3xl bg-white text-primary rounded-full cursor-pointer top-10 -right-4 shadow-md z-50 border border-slate-100 hover:bg-primaryLight hover:scale-110 transition-all duration-300`}
          onClick={() => setSidebarOpen(!open)}
        />

        <div className={`flex items-center ${open ? "px-6" : "justify-center"} h-24 border-b border-slate-100`}>
          <div className="flex items-center gap-x-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-primary to-accent text-white font-bold text-lg shadow-lg">
              VT
            </div>
            {open && (
              <div className="flex flex-col whitespace-nowrap animate-fade-in">
                <h1 className="text-sm font-bold text-slate-800 tracking-wide uppercase">VisionTrek</h1>
                <span className="text-xs text-slate-500 font-medium">Admin Portal</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex-1 overflow-y-auto py-6 px-4 no-scrollbar">
          <ul className="space-y-1.5">
            {Menus.map((menu, index) => {
              const isActive = location.pathname === menu.path;
              return (
                <Link to={menu.path} key={index}>
                  <li
                    className={`flex items-center ${
                      !open ? "justify-center" : "justify-start"
                    } gap-x-4 p-3 rounded-xl cursor-pointer transition-all duration-200 group
                    ${
                      isActive
                        ? "bg-primary text-white shadow-md shadow-primary/20"
                        : "text-slate-600 hover:bg-primaryLight hover:text-primary"
                    }`}
                  >
                    <span
                      className={`text-xl transition-colors duration-200 ${
                        isActive ? "text-white" : "text-slate-400 group-hover:text-primary"
                      }`}
                    >
                      {menu.src}
                    </span>

                    <span
                      className={`${
                        !open && "hidden"
                      } origin-left duration-200 text-[15px] font-medium whitespace-nowrap`}
                    >
                      {menu.title}
                    </span>
                  </li>
                </Link>
              );
            })}
          </ul>
        </div>
      </div>

      {/* Mobile Header / Hamburger */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-white/80 backdrop-blur-md border-b border-slate-200 z-30 flex items-center justify-between px-4">
         <div className="flex items-center gap-x-3">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-primary to-accent text-white font-bold text-sm shadow-md">
              VT
            </div>
            <h1 className="text-sm font-bold text-slate-800 tracking-wide uppercase">VisionTrek</h1>
          </div>
          {!mobileMenu && (
            <div className="scale-75 origin-right">
                <HamburgerButton setMobileMenu={setMobileMenu} mobileMenu={mobileMenu} />
            </div>
          )}
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileMenu && (
        <div 
          className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40 lg:hidden animate-fade-in"
          onClick={() => setMobileMenu(false)}
        />
      )}

      {/* Mobile Sidebar Content */}
      <div className="lg:hidden">
        <div
          className={`fixed top-0 left-0 h-full w-[280px] z-50 bg-white shadow-2xl transform transition-transform duration-300 ease-out flex flex-col ${
            mobileMenu ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between h-20 px-6 border-b border-slate-100">
            <div className="flex items-center gap-x-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-primary to-accent text-white font-bold text-lg shadow-lg">
                VT
              </div>
              <div className="flex flex-col">
                <h1 className="text-sm font-bold text-slate-800 tracking-wide uppercase">VisionTrek</h1>
                <span className="text-xs text-slate-500 font-medium">Admin Portal</span>
              </div>
            </div>

            <button
              onClick={() => setMobileMenu(false)}
              className="p-2 -mr-2 rounded-xl text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
            >
              <ImCross size={14} />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto py-6 px-4">
            <ul className="space-y-2">
              {Menus.map((menu, index) => {
                 const isActive = location.pathname === menu.path;
                 return (
                  <Link
                    to={menu.path}
                    key={index}
                    onClick={() => setMobileMenu(false)}
                  >
                    <li
                      className={`flex items-center gap-x-4 p-3.5 rounded-xl cursor-pointer transition-all duration-200 group
                      ${
                        isActive
                          ? "bg-primary text-white shadow-md shadow-primary/20"
                          : "text-slate-600 hover:bg-primaryLight hover:text-primary"
                      }`}
                    >
                      <span className={`text-xl transition-colors duration-200 ${isActive ? "text-white" : "text-slate-400 group-hover:text-primary"}`}>
                        {menu.src}
                      </span>
                      <span className="text-[15px] font-medium">{menu.title}</span>
                    </li>
                  </Link>
                 )
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
